module.exports = __webpack_public_path__ + "static/media/imac.2521b06d.png";